var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructuringIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6625 16.2196H41.3915V2.35056C41.3915 1.73751 41.1409 1.14958 40.6949 0.716085C40.2488 0.282595 39.6438 0.0390625 39.013 0.0390625H3.33553C2.70471 0.0390625 2.09973 0.282595 1.65368 0.716085C1.20762 1.14958 0.957031 1.73751 0.957031 2.35056V37.0231C0.957031 37.6361 1.20762 38.224 1.65368 38.6575C2.09973 39.091 2.70471 39.3346 3.33553 39.3346H17.6065V53.2035C17.6065 53.8166 17.8571 54.4045 18.3032 54.838C18.7492 55.2715 19.3542 55.515 19.985 55.515H55.6625C56.2933 55.515 56.8983 55.2715 57.3444 54.838C57.7904 54.4045 58.041 53.8166 58.041 53.2035V18.5311C58.041 17.918 57.7904 17.3301 57.3444 16.8966C56.8983 16.4631 56.2933 16.2196 55.6625 16.2196ZM5.71403 34.7116V4.66206H36.6345V16.2196H19.985C19.3542 16.2196 18.7492 16.4631 18.3032 16.8966C17.8571 17.3301 17.6065 17.918 17.6065 18.5311V34.7116H5.71403ZM22.3635 24.1104L33.2719 34.7116H22.3635V24.1104ZM36.6345 31.4437L25.7261 20.8426H36.6345V31.4437ZM53.284 50.892H22.3635V39.3346H39.013C39.6438 39.3346 40.2488 39.091 40.6949 38.6575C41.1409 38.224 41.3915 37.6361 41.3915 37.0231V20.8426H53.284V50.892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuringIcon);
export default __webpack_public_path__ + "static/media/StructuringIcon.e3c5ef0d0c4372db2bfdf1bbdae91b56.svg";
export { ForwardRef as ReactComponent };